import React from 'react'
import PropTypes from 'prop-types'

import { Text } from 'components/text/Text'

export const formatDefault = ({ item }) => <div className="list-item">{item}</div>

formatDefault.propTypes = {
  item: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string, PropTypes.number, PropTypes.bool])
    .isRequired,
}

export const rowTitleFormatDefault = ({ title }) => <Text weight="bold">{title}</Text>

rowTitleFormatDefault.propTypes = {
  title: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string, PropTypes.number, PropTypes.bool])
    .isRequired,
}
